import React, { useState, useEffect } from "react"
import { useHistory } from "react-router-dom"
import { isBlackFridayLastMinutePopupActive } from "utils/dateUtils"
import { ENABLE_BLACK_FRIDAY_LAST_MINUTE_POPUP } from "config/campaignFeatureToggles"
import "./BlackFridayLastMinutePopup.scss"

const BlackFridayLastMinutePopup = () => {
  const [isVisible, setIsVisible] = useState(true)
  const history = useHistory()

  const STORAGE_KEY = "blackFridayLastMinutePopup2025Dismissed"

  useEffect(() => {
    const wasClosed = sessionStorage.getItem(STORAGE_KEY)
    if (wasClosed === "true") {
      setIsVisible(false)
    }
  }, [])

  // Check feature toggle and date conditions
  if (!ENABLE_BLACK_FRIDAY_LAST_MINUTE_POPUP) return null
  if (!isBlackFridayLastMinutePopupActive()) return null
  if (!isVisible) return null

  const handleClose = () => {
    setIsVisible(false)
    sessionStorage.setItem(STORAGE_KEY, "true")
  }

  const handleViewProducts = () => {
    const blackFridayUrl = '/shop/productlist?filters=%7B"FLT-CATEG001"%3A%5B"%2327616"%5D%7D&page=1&sortBy=ranking'
    history.push(blackFridayUrl)
    handleClose()
  }

  return (
    <div className="black-friday-last-minute-popup">
      <div className="black-friday-last-minute-popup__header">
        <h4 className="black-friday-last-minute-popup__title">
          ⏰ Ultima șansă pentru ofertele Black Friday!
        </h4>
        <button
          onClick={handleClose}
          className="black-friday-last-minute-popup__close-button"
          title="Închide"
        >
          ×
        </button>
      </div>
      <div className="black-friday-last-minute-popup__content">
        <p>
          Grăbește-te, se încheie azi!
        </p>
        <button
          onClick={handleViewProducts}
          className="black-friday-last-minute-popup__cta-button"
        >
          Vezi produsele
        </button>
      </div>
    </div>
  )
}

export default BlackFridayLastMinutePopup
